import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-54e85bfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 3 }
const _hoisted_2 = ["src"]
const _hoisted_3 = { key: 1 }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ant-upload-text" }, "上传", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_layout = _resolveComponent("a-layout")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_loading_outlined = _resolveComponent("loading-outlined")!
  const _component_plus_outlined = _resolveComponent("plus-outlined")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_TheFooter = _resolveComponent("TheFooter")!

  return (_openBlock(), _createBlock(_component_a_layout, { style: {"padding-top":"65px"} }, {
    default: _withCtx(() => [
      _createVNode(_component_a_layout, null, {
        default: _withCtx(() => [
          _createVNode(_component_a_tabs, {
            activeKey: _ctx.activeKey,
            "onUpdate:activeKey": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeKey) = $event)),
            type: "card",
            style: {"margin-top":"0px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_tab_pane, {
                key: "1",
                tab: "推荐文章"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_layout, { style: {"margin":"0px 0px 5px 10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form, {
                        layout: "inline",
                        model: _ctx.param
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleQueryArticle({ page: 1, size: _ctx.pagination.pageSize })))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 查询 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_layout_content, { style: { background: '#fff', padding: '24px', margin: 0, minHeight: '280px' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.columns,
                        "data-source": _ctx.articles,
                        pagination: _ctx.pagination,
                        loading: _ctx.loading,
                        onChange: _ctx.handleTableChange
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.dataIndex === 'sort')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(record.sort), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'coverUrl')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (record.articleVO.coverUrl)
                                  ? (_openBlock(), _createBlock(_component_a_image, {
                                      key: 0,
                                      width: 52,
                                      preview: true,
                                      src: record.articleVO.coverUrl,
                                      alt: "avatar"
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'title')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(record.articleVO.title), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'category')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(record.articleVO.category1.name) + " / " + _toDisplayString(record.articleVO.category2.name), 1))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'description')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                                _createTextVNode(_toDisplayString(record.articleVO.description), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'viewCount')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                _createTextVNode(_toDisplayString(record.articleVO.viewCount), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'voteCount')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                                _createTextVNode(_toDisplayString(record.articleVO.voteCount), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'status')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 7 }, [
                                (record.articleVO.status == 0)
                                  ? (_openBlock(), _createBlock(_component_a_tag, {
                                      key: 0,
                                      color: "orange"
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("未发布")
                                      ]),
                                      _: 1
                                    }))
                                  : (record.articleVO.status == 1)
                                    ? (_openBlock(), _createBlock(_component_a_tag, {
                                        key: 1,
                                        color: "green"
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("已发布")
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'action')
                            ? (_openBlock(), _createBlock(_component_a_space, {
                                key: 8,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_router_link, {
                                    to: '/doc?articleId=' + record.articleId,
                                    slots: "a",
                                    target: "_blank"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, { type: "primary" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" 预览 ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]),
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: ($event: any) => (_ctx.editArticle(record))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 编辑 ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_a_popconfirm, {
                                    title: "删除后不可恢复，确认删除?",
                                    "ok-text": "是",
                                    "cancel-text": "否",
                                    onConfirm: ($event: any) => (_ctx.handleDelete(record.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "primary",
                                        danger: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" 删除 ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "pagination", "loading", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_a_tab_pane, {
                key: "2",
                tab: "轮播图"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_layout, { style: {"margin":"0px 0px 5px 10px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_form, {
                        layout: "inline",
                        model: _ctx.param
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: _ctx.addBanner
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 增加 ")
                                ]),
                                _: 1
                              }, 8, ["onClick"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_form_item, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_a_button, {
                                type: "primary",
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleQueryBanner({ page: 1, size: _ctx.pagination.pageSize })))
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(" 查询 ")
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["model"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_a_layout_content, { style: { background: '#fff', padding: '24px', margin: 0, minHeight: '280px' } }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_table, {
                        columns: _ctx.columnsBanner,
                        "data-source": _ctx.banners,
                        pagination: _ctx.paginationBanner,
                        loading: _ctx.loading,
                        onChange: _ctx.handleBannerTableChange
                      }, {
                        bodyCell: _withCtx(({ column, record }) => [
                          (column.dataIndex === 'sort')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(record.sort), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'bannerUrl')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                (record.bannerUrl)
                                  ? (_openBlock(), _createBlock(_component_a_image, {
                                      key: 0,
                                      width: 52,
                                      preview: true,
                                      src: record.bannerUrl,
                                      alt: "avatar"
                                    }, null, 8, ["src"]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'link')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(record.link), 1)
                              ], 64))
                            : _createCommentVNode("", true),
                          (column.dataIndex === 'action')
                            ? (_openBlock(), _createBlock(_component_a_space, {
                                key: 3,
                                size: "small"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_a_button, {
                                    type: "primary",
                                    onClick: ($event: any) => (_ctx.editBanner(record))
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(" 编辑 ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_a_popconfirm, {
                                    title: "删除后不可恢复，确认删除?",
                                    "ok-text": "是",
                                    "cancel-text": "否",
                                    onConfirm: ($event: any) => (_ctx.handleDelete(record.id))
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_button, {
                                        type: "primary",
                                        danger: ""
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(" 删除 ")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1032, ["onConfirm"])
                                ]),
                                _: 2
                              }, 1024))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["columns", "data-source", "pagination", "loading", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["activeKey"])
        ]),
        _: 1
      }),
      _createVNode(_component_a_modal, {
        title: "文章序号",
        open: _ctx.modalArticleVisible,
        "onUpdate:open": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.modalArticleVisible) = $event)),
        "confirm-loading": _ctx.modalLoading,
        onOk: _ctx.handleModalOk
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            model: _ctx.recommend,
            "label-col": { span: 6 },
            "wrapper-col": { span: 18 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "序号" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.recommend.sort,
                    "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.recommend.sort) = $event)),
                    allowClear: true,
                    type: "number",
                    min: "1",
                    placeholder: "请输入序号"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["open", "confirm-loading", "onOk"]),
      _createVNode(_component_a_modal, {
        title: "轮播图表单",
        open: _ctx.modalBannerVisible,
        "onUpdate:open": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.modalBannerVisible) = $event)),
        "confirm-loading": _ctx.modalLoading,
        onOk: _ctx.handleModalOk
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, {
            model: _ctx.recommend,
            "label-col": { span: 6 },
            "wrapper-col": { span: 18 }
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_form_item, { label: "图片" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.recommend.banner,
                    "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.recommend.banner) = $event)),
                    disabled: true,
                    allowClear: true
                  }, null, 8, ["value"]),
                  _createVNode(_component_a_upload, {
                    "file-list": _ctx.fileList,
                    "onUpdate:fileList": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fileList) = $event)),
                    name: "file",
                    "list-type": "picture-card",
                    class: "avatar-uploader",
                    "show-upload-list": false,
                    action: _ctx.SERVER + '/file/upload/avatar',
                    "before-upload": _ctx.beforeUpload,
                    headers: _ctx.uploadHeaders,
                    onChange: _ctx.handleChange
                  }, {
                    default: _withCtx(() => [
                      (_ctx.imageUrl)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.imageUrl,
                            alt: "avatar"
                          }, null, 8, _hoisted_2))
                        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            (_ctx.coverLoading)
                              ? (_openBlock(), _createBlock(_component_loading_outlined, { key: 0 }))
                              : (_openBlock(), _createBlock(_component_plus_outlined, { key: 1 })),
                            _hoisted_4
                          ]))
                    ]),
                    _: 1
                  }, 8, ["file-list", "action", "before-upload", "headers", "onChange"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "链接" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.recommend.link,
                    "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.recommend.link) = $event)),
                    allowClear: true,
                    placeholder: "请输入链接url"
                  }, null, 8, ["value"])
                ]),
                _: 1
              }),
              _createVNode(_component_a_form_item, { label: "序号" }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_input, {
                    value: _ctx.recommend.sort,
                    "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.recommend.sort) = $event)),
                    allowClear: true,
                    type: "number",
                    min: "1",
                    placeholder: "请输入序号"
                  }, null, 8, ["value"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      }, 8, ["open", "confirm-loading", "onOk"]),
      _createVNode(_component_TheFooter)
    ]),
    _: 1
  }))
}